import moment from 'moment'
import React from 'react'
import { Table } from 'react-bootstrap'

interface IReverificationsTable {
    tableData: any
}

export default function ReverificationTable(props: IReverificationsTable) {
    return (
        <Table striped hover responsive>
            <thead>
                <tr>
                    <th style={{ fontSize: 14 }}>S.No</th>
                    <th style={{ fontSize: 14 }}>CET Roll Number</th>
                    <th style={{ fontSize: 14 }}>CET Application Number</th>
                    <th style={{ fontSize: 14 }}>Candidate Name</th>
                    <th style={{ fontSize: 14 }}>Institute Code</th>
                    <th style={{ fontSize: 14 }}>Institute Name </th>
                    <th style={{ fontSize: 14 }}>Stream</th>
                    <th style={{ fontSize: 14 }}>Verification Status</th>
                    <th style={{ fontSize: 14 }}>Verification Time</th>
                </tr>
            </thead>
            <tbody>
                {props.tableData?.length > 0 ? (
                    props.tableData.map((item: any, index: number) => (
                        <tr key={item?._id}>
                            <td style={{ fontSize: 12 }}>{index + 1}</td>
                            <td style={{ fontSize: 12 }}>{item?.studentId?.reVerification_meta?.["CET Application No"]}</td>
                            <td style={{ fontSize: 12 }}>{item?.studentId?.reVerification_meta?.["CAP Application ID"]}</td>
                            <td style={{ fontSize: 12 }}>{item?.studentId?.name}</td>
                            <td style={{ fontSize: 12 }}>{item?.studentId?.reVerification_meta?.["Alloted Institute Code"]}</td>
                            <td style={{ fontSize: 12 }}>{item?.studentId?.reVerification_meta?.["Alloted Institute Name"]}</td>
                            <td style={{ fontSize: 12 }}>{item?.studentId?.reVerification_meta?.Stream}</td>
                            <td style={{ fontSize: 12 }}>{item?.success ? <span className='text-success'>Success</span>:<span className='text-warning'>Not-Success</span>}</td>
                            <td style={{ fontSize: 12 }}>{moment(item?.updatedAt).format("DD-MM-YYYY, hh:mm A")}</td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={12} className="text-center">
                            No Data Available
                        </td>
                    </tr>
                )}
            </tbody>
        </Table>
    )
}
